/* eslint-disable no-unused-vars */
import axios from 'axios';
import { useContext } from 'react';
import { getTotalFromSimulation, runSimulation } from '../components/utils/creditSimulation';
import { CotizadorContext } from '../context';
import useSimulationData from './useSimulationData';

const useCarsData = () => {
    const [state, setState] = useContext(CotizadorContext)
    const { simulate } = useSimulationData();

    const getCars = async () => {
        const response = await axios.get('/api/kinto/one_personal_cars');
        setState(prevState => ({
            ...prevState,
            available_cars: response?.data
        }))
    }

    const getSelectedCar = () => {
        if (state.selected_car) {
            const car = state.available_cars.find(car => car.id === state.selected_car);
            return car;
        }

        return null;
    }

    const setSelectedCar = async selected_car => {        
        // Buscar el auto completo para las simulaciones
        const car = state.available_cars.find(c => c.id === selected_car);
        if (!car) {
            console.warn('⚠️ [useCarsData] No se encontró el auto con ID:', selected_car);
            return; // Salir sin error
        }
        
        // Actualizar el auto seleccionado ANTES de hacer la simulación
        // Así, si la simulación falla, el auto seleccionado ya está actualizado
        setState(prevState => {
            const newState = {
                ...prevState,
                selected_car,
                simulation_results: null,
                simulation_total: 0,
                min_price: {
                    simulation12: null,
                    simulation24: null,
                    simulation36: null,
                    simulation48: null,
                }
            };
            return newState;
        });
        
        document.getElementById('cotizador_overlay').style.display = 'block';
        
        const simulationResult = await runSimulation(selected_car, state.selected_time, state.selected_distance, state.downpayment_percentage);
        
        // Inicializar variables para la simulación principal
        let simulation = null;
        let simulationTotal = 0;
        
        if (!simulationResult.success) {
            console.error('[useCarsData] Error en simulación principal:', simulationResult.error);
            // Mostrar error al usuario pero CONTINUAR con los precios mínimos
            setState(prevState => ({
                ...prevState,
                error_notification: simulationResult.error
            }));
        } else {
            simulation = simulationResult.data;
            simulationTotal = getTotalFromSimulation(simulation);
        }
        
        const sim12 = { value: 12 }
        const sim24 = { value: 24 }
        const sim36 = { value: 36 }
        const sim48 = { value: 48 }
        
        // Kilometrajes disponibles
        const kmOptions = [
            { value: 10000 },
            { value: 12000 },
            { value: 15000 },
            { value: 18000 },
            { value: 20000 },
            { value: 24000 }
        ];

        // Función para obtener el precio de un período
        // Prioriza el kilometraje seleccionado, luego prueba otros
        const getMinPriceForPeriod = async (period) => {
            const orderedKmOptions = [...kmOptions];
            const selectedKmIndex = orderedKmOptions.findIndex(
                km => km.value === state.selected_distance.value
            );
            
            // Si se encontró el kilometraje seleccionado, moverlo al inicio
            if (selectedKmIndex !== -1) {
                const selectedKm = orderedKmOptions.splice(selectedKmIndex, 1)[0];
                orderedKmOptions.unshift(selectedKm);
            }
            
            // Intentar con cada kilometraje en orden
            for (const km of orderedKmOptions) {
                const result = await runSimulation(selected_car, period, km, '0');
                if (result.success) {
                    const price = getTotalFromSimulation(result.data);
                    if (price > 0) {
                        return price;
                    }
                }
            }
            console.log(`[useCarsData] No se encontró precio para ${period.value} meses`);
            return null;
        };

        // Obtener precios mínimos, manejando posibles errores
        const [price12, price24, price36, price48] = await Promise.all([
            getMinPriceForPeriod(sim12),
            getMinPriceForPeriod(sim24),
            getMinPriceForPeriod(sim36),
            getMinPriceForPeriod(sim48)
        ]);

        // Calcular precios mínimos solo si la simulación fue exitosa
        const minPrice = {
            simulation12: price12,
            simulation24: price24,
            simulation36: price36,
            simulation48: price48,
        };
        
        const newState = {
            selected_car,
            simulation_results: simulation,
            simulation_total: simulationTotal,
            simulation_error: null,
            min_price: minPrice
        };
        
        setState(prevState => ({
            ...prevState,
            ...newState
        }));

        document.getElementById('cotizador_overlay').style.display = 'none';
    }
   
    return {
        cars: state.available_cars,
        getSelectedCar,
        setSelectedCar,
        getCars
    };
}

export default useCarsData;